import React, { useRef } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function HomeWedding() {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 3,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: false,
    cssEase: "ease",
    draggable: false,
    swipe: false,
    responsive: [
        {
          breakpoint: 991,
          settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true, },
        },
        {
            breakpoint: 767,
            settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true, },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 1, draggable: true, swipe: true, autoplay: true,}
        },
    ],
  };

    const CustomArrows = () => (
        <>
        <div className="default-arrowleft default-mobilearrow" onClick={() => sliderRef.current.slickPrev()}>
            <Icons name="arrowLeft" />
        </div>
        <div className="default-arrowright default-mobilearrow" onClick={() => sliderRef.current.slickNext()}>
            <Icons name="arrowRight" />
        </div>
        </>
    );

  return (
    <>
    <section className="home-wedding bodygap">
        <h4 className="heading">Curated Wedding Luxuries</h4>
        
        <Slider {...settings} ref={sliderRef}>
            <div>
                <div className="wedding-slider">
                    <img src="/image/wedding-slide-1.webp" className="img-responsive" alt="wedding" loading="lazy"/>
                    <div>
                        <h4 className="heading">Banno</h4>
                        <p>Customised Bridal Wear</p>
                        <Link to={"/wedding-dress-designers"} className="default-btn">Consult Now</Link>
                    </div>
                </div>
            </div>

            <div>
                <div className="wedding-slider">
                    <img src="/image/wedding-slide-2.webp" className="img-responsive" alt="wedding" loading="lazy"/>
                    <div>
                        <h4 className="heading">Mittrika</h4>
                        <p>Couture Wear for Friends and Family</p>
                        <Link to={"/contemporary"} className="default-btn">Consult Now</Link>
                    </div>
                </div>
            </div>

            <div>
                <div className="wedding-slider">
                    <img src="/image/wedding-slide-3.webp" className="img-responsive" alt="wedding" loading="lazy"/>
                    <div>
                        <h4 className="heading">Riwaayat</h4>
                        <p>Customised Gifting and Packaging</p>
                        <Link to={"/gifting"} className="default-btn">Consult Now</Link>
                    </div>
                </div>
            </div>
        </Slider>

        <CustomArrows />
    </section>
    </>
  )
}
